<template>
  <div class="panic-detail-body">
    <div class="panic-detail-nav">
      <nav-bar :lefticon="back_black_icon" :lefticonshow="true" title="明细详情" @goback="goBack"></nav-bar>
    </div>
    <div class="main">
      <div class="panic-detail-first-div">{{real_title}}</div>
      <div class="panic-detail-second-div">{{is_inc ? '+':"-"}}{{panic_info.money_real || panic_info.balance}}</div>
      <div class="panic-detail-three-div" v-show="!is_inc && (transaction_type == 21 || transaction_type == 22)">
        <div class="icon-div"><img :src="finished_icon" alt=""><span>发起提现申请</span></div>
        <div class="solid-line"></div>
        <div class="icon-div"><img :src="panic_info.status == 'created' ? pending_icon: finished_icon" :class="{'active-img': panic_info.status !== 'paid' && panic_info.status !== 'refused'}" alt=""><span :class="{'active-span':panic_info.status !== 'paid' && panic_info.status !== 'refused'}">{{panic_info.channel_name}}处理中</span></div>
        <div class="dotted-line" :class="{'solid-line': panic_info.status == 'paid' || panic_info.status == 'refused'}"></div>
        <div class="icon-div"><img :src="(panic_info.status == 'paid' || panic_info.status == 'refused') ? finished_icon: feature_icon" alt="" :class="{'active-img': (panic_info.status == 'paid' || panic_info.status == 'refused')}"><span :class="{'active-span':(panic_info.status == 'paid' || panic_info.status == 'refused')}">{{panic_info.status == 'paid' ? '提现成功' : ((panic_info.status == 'refused' || panic_info.status == 'failed') ? '提现失败': '提现成功') }}</span></div>
      </div>
      <div class="panic-detail-text-div pd-top"><span>收支类型</span><span>{{is_inc? '收入':'支出'}}</span></div>
      <div class="panic-detail-text-div" v-show="!is_inc && (transaction_type == 21 || transaction_type == 22)"><span>提现金额</span><span>¥{{panic_info.money_real}}</span></div>
      <div class="panic-detail-text-div" v-show="!is_inc && (transaction_type == 21 || transaction_type == 22)"><span>申请时间</span><span>{{panic_info.create_time}}</span></div>
      <div class="panic-detail-text-div" v-show="!is_inc && (transaction_type == 21 || transaction_type == 22) && panic_info.status !== 'refused'"><span>到账时间</span><span>{{panic_info.finish_time}}</span></div>
      <div class="panic-detail-text-div" v-show="!is_inc && (transaction_type == 21 || transaction_type == 22)"><span>提现渠道</span><span>{{panic_info.channel_name}}</span></div>
      <div class="panic-detail-text-div" v-show="!is_inc && (transaction_type == 21 || transaction_type == 22)"><span>提现单号</span><span>{{panic_info.ordersn}}</span></div>

      <div class="panic-detail-text-div" v-show="is_inc && ( transaction_type == 22 || transaction_type == 14)"><span>退款金额</span><span>¥{{transaction_type == 14 ? panic_info.balance : panic_info.money_real || panic_info.balance}}</span></div>
      <div class="panic-detail-text-div" v-show="is_inc &&  transaction_type == 22"><span>退款时间</span><span>{{panic_info.finish_time}}</span></div>
      <!-- <div class="panic-detail-text-div" v-show="is_inc"><span>支付方式</span><span>{{panic_info.channel_name}}</span></div> -->
      <div class="panic-detail-text-div" v-show="is_inc && ( transaction_type == 22 || transaction_type == 14)"><span>订单编号</span><span>{{panic_info.relation_order || panic_info.ordersn}}</span></div>

      <div class="panic-detail-text-div" v-show="!is_inc && transaction_type == 20"><span>商品金额</span><span>¥{{panic_info.balance}}</span></div>
      <div class="panic-detail-text-div" v-show="!is_inc && transaction_type == 20"><span>下单时间</span><span>{{panic_info.create_time}}</span></div>
      <div class="panic-detail-text-div" v-show="!is_inc && transaction_type == 20"><span>订单编号</span><span>{{panic_info.relation_order}}</span></div>
      <div class="panic-detail-text-div" v-show="transaction_type == 22"><span>备注</span><span>{{panic_info.remark|| '/'}}</span></div>
    </div>
    <centerrscreenloading :loading="page_loading" />
  </div>
</template>

<script>
  import navBar from '@/components/nav-bar.vue'
  import centerrscreenloading from '@/components/centerrscreen-loading.vue'
  import { apiFinanceMembernAccountRecordDetail, apiFinanceMembernWithdrawRecordDetail } from './api'
  export default {
    components: { navBar, centerrscreenloading },
    data () {
      return {
        back_black_icon: require("@/assets/groupRob/back-black-icon.png"),
        finished_icon: require("@/assets/groupRob/finished-icon.png"),
        pending_icon: require("@/assets/groupRob/pending-icon.png"),
        feature_icon: require("@/assets/groupRob/feature-icon.png"),
        page_loading: true,
        panic_info: {},
        is_inc: false, // 是否是收入
        real_title: '',
        transaction_type:20
      }
    },
    async created () {
      this.transaction_type = this.$route.query.transaction_type
      this.real_title = this.$route.query.real_title
      if (this.$route.query.balance.indexOf('-') <0) {
        this.is_inc = true
      }
      if ((this.$route.query.balance.indexOf('-') > -1 || this.$route.query.transaction_type == 22) && this.$route.query.title == '提现') {
        await apiFinanceMembernWithdrawRecordDetail({ ordersn: this.$route.query.ordersn }).then((res) => {
          this.panic_info = res
          this.page_loading = false
        })
      } else {
        await apiFinanceMembernAccountRecordDetail({ id: this.$route.query.id }).then((res) => {
          this.panic_info = res
          this.page_loading = false
        })
      }
    },
    methods: {
      goBack () {
        this.$router.go(-1)
      }
    }
  }
</script>

<style lang="less" scoped>
  .panic-detail-body {
    min-height: 100vh;
    background: #F4F5F6;
    overflow: hidden;

    .panic-detail-nav {
      position: fixed;
      top: 0;
      padding-top: 44px;
      left: 0;
      width: 100vw;
      background: #fff;
    }

    .main {
      background: #fff;
      min-height: calc(100vh - 108px);

      .panic-detail-first-div {
        margin-top: 108px;
        padding-top: 50px;
        padding-bottom: 5px;
        text-align: center;
        height: 22px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.8);
        line-height: 22px;
      }

      .panic-detail-second-div {
        height: 42px;
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 42px;
        text-align: center;
        padding-bottom: 30px;
      }

      .panic-detail-three-div {
        padding-top: 20px;
        padding-left: 33px;

        .icon-div {
          display: flex;
          align-items: center;

          img {
            width: 20px;
            height: 20px;
            margin-right: 12px;
            margin-left: 8px;
          }

          span {
            height: 24px;
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 24px;
          }

          &:nth-child(3) {
            margin-top: -2px;
          }

          .active-span {
            color: #333333;
          }

          .active-img {
            width: 36px;
            height: 36px;
            margin-left: 0;
          }

          &:nth-child(5) {
            margin-top: -2px;
            margin-bottom: 40px;
          }
        }

        .dotted-line {
          width: 2px;
          height: 38px;
          border-left: 2px dotted #F9591B;
          margin-left: 16px;
          margin-top: -2px;
        }

        .solid-line {
          width: 2px;
          height: 38px;
          border-left: 2px solid #F9591B;
          margin-left: 16px;
          margin-top: -2px;

        }
      }

      .panic-detail-text-div {
        display: flex;
        margin-bottom: 9px;
        padding-left: 33px;

        &:last-child {
          padding-bottom: 60px;
        }

        span {
          &:nth-child(1) {
            height: 24px;
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 24px;
            margin-right: 24px;
            width: 60px;
            text-align: right;
          }

          &:nth-child(2) {
            flex: 1;
            height: 24px;
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
          }
        }
      }

      .pd-top {
        padding-top: 40px;
        border-top: 1px solid #EEEEEE;
        width: calc(100vw - 66px);
      }
    }
  }
</style>